import * as z from "zod";

       // eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createProfileSchema = (t: any) => {
  return z.object({
    first_name: z
      .string()
      .min(2, t("auth.onboarding.validation.firstNameMinLength"))
      .max(50, t("auth.onboarding.validation.firstNameMaxLength")),
    last_name: z
      .string()
      .min(2, t("auth.onboarding.validation.lastNameMinLength"))
      .max(50, t("auth.onboarding.validation.lastNameMaxLength")),
  });
};

// Schema para o campo função que foi movido para o SurveyStep
       // eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createFunctionSchema = (t: any) => {
  return z.object({
    function: z
      .string()
      .min(2, t("auth.onboarding.validation.functionMinLength"))
      .max(100, t("auth.onboarding.validation.functionMaxLength")),
  });
};
